import locationsRouter from './locationsRouter';

export default locationsRouter;
